/**
 * Authentication Context - SIMPLIFIED
 */

import { createContext, useState, useEffect } from 'react';
import { authService } from '../api/services/authService';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // Initialize from localStorage immediately
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    try {
      const response = await authService.login({ email, password });
      
      if (response?.status === 'success' && response?.data?.user) {
        setUser(response.data.user);
        return { success: true, user: response.data.user };
      }
      
      return { success: false, error: response?.message || 'Login failed' };
    } catch (error) {
      return { success: false, error: error.message || 'Login failed' };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};
